<template>
  <v-app class="us-v-app">
    <v-app-bar color="blue-grey" dense dark app>
      <v-btn icon @click="goBack">
        <v-icon style="font-size:2rem;">mdi-chevron-left</v-icon>
      </v-btn>
      <v-toolbar-title style="font-size:1rem;width:95%;padding-left:0.4rem;">
        <span style="width:100%;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;display:inline-block;margin-top:0.56rem;">团队报障单
          <span v-if="companyInfo.COMPANY_NAME"> - {{companyInfo.COMPANY_NAME}}</span>
        </span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-content>
      <v-container style="font-size:0.9rem;padding-top:1rem;padding-bottom:2rem;">
        <div>
          <!-- <div style="height:30px;">
            <span class="us_block_more_text" @click="goCurOrderStat">
              <i class="fa fa-bar-chart" aria-hidden="true"></i>
              <span> 统计</span><i class="fa fa-angle-right" aria-hidden="true"></i>
            </span>
          </div> -->
          <CompanyOrderList ref="CompanyOrderList" v-if="!loading" />
        </div>
        <div class="us-create-btn" @click="goCreateOrder">
          <v-btn dark fab right color="#5cbbf6"><v-icon>mdi-plus</v-icon></v-btn>
        </div>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import CompanyOrderList from './components/CompanyOrderList'
export default {
  components: { CompanyOrderList },
  props: {},
  data() {
    return {
      loading: true,
      companyInfo: {}
    };
  },
  computed: {},
  mounted() {
  },
  activated() {
    var that = this
    that.companyInfo = that.$AppHelper.getCustomData('company_info');
    that.loading = false
    that.$nextTick(function() {
      that.$refs.CompanyOrderList.initData()
    })
  },
  created() {},
  methods: {
    goBack: function() {
      var that = this;
      that.$router.goBack()
    },
    goCurOrderStat() {
      this.$router.goPage('/CurOrderStat')
    },
    goCreateOrder() {
      // this.$router.goPage('/CreateOrder')
      this.$router.goPage({
        path: '/CreateOrder',
        query: { type: 1 }
      })
    }
  }
};
</script>

<style scoped>

.us-v-app{
  background-color: #f2f2f2;
}

.us-create-btn{
  position:fixed;
  bottom: 1rem;
  right: 1.5rem;
}

.us-back-lucency {
  background-color: rgba(255, 255, 255, 0.08) !important;
  color: #fff !important;
  cursor: pointer;
  box-shadow: 1px 1px 5px 1px rgba(255, 255, 255, 0.4) !important;
}
.us-lucency-border {
  border-top: 1px solid #f5f5f5;
}

.us_block_more_text{
  font-size:0.8rem;
  padding-top:0.3rem;
  padding-right:0.4rem;
  float:right;
  color:#9e9e9e;
}
.us_block_more_text span{
  font-size:0.8rem;
}
.us_block_more_text i{
  margin-left:0.4rem;
}
</style>
